/*
 * Pre-order availability for products that launch on a future date.
 *
 * window.preorderItems (rendered by snippets/preorder-availability.liquid)
 * maps variant id to { from: "YYYY-MM-DD", title: "Product name",
 * label: "Winter Menu" } for products whose custom.available_from date is
 * still in the future. The label comes from custom.availability_label and
 * falls back to "Coming soon".
 *
 * This script does three things:
 *
 *   1. Product page: adds a badge above the title ("Winter Menu, available
 *      from 1 October"), relabels the "Add to cart" button as a pre-order
 *      button and adds a note with the first delivery date.
 *   2. Product cards: adds the same badge on the image and relabels the
 *      quick add button on collection pages.
 *   3. Cart: when the basket holds a pre-order item, shows a notice above
 *      the delivery date picker explaining why earlier dates are greyed
 *      out and how to get round it, and hides the theme's own
 *      "Estimated delivery earliest ..." line, which would contradict it.
 *
 * Nothing here stops a customer ordering. The delivery dates themselves
 * are controlled by the DS Delivery Date-Time app.
 */
(function () {
  var items = window.preorderItems || {};

  function itemFor(variantId) {
    if (variantId === undefined || variantId === null) return null;
    return items[String(variantId)] || null;
  }

  function longDate(iso) {
    var parts = String(iso).split('-');
    var date = new Date(Date.UTC(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10)));
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', timeZone: 'UTC' });
  }

  /* Only touch the DOM when the text really changes, so the mutation
     observer below does not keep waking itself up. */
  function setText(el, text) {
    if (el.textContent !== text) el.textContent = text;
  }

  function buttonLabel(item) {
    return 'Pre-order for delivery from ' + longDate(item.from);
  }

  function badgeText(item) {
    return item.label + ' · from ' + longDate(item.from);
  }

  function makeBadge(item, className) {
    var badge = document.createElement('span');
    badge.className = className;
    badge.style.cssText = 'display:inline-block;background:#10846f;color:#fff;font-size:12px;'
      + 'font-weight:600;line-height:1;letter-spacing:.02em;padding:6px 10px;border-radius:999px;'
      + 'white-space:nowrap;pointer-events:none;';
    badge.textContent = badgeText(item);
    return badge;
  }

  /* ---------- 1. Product page ---------- */

  function applyToProductButtons() {
    var buttons = document.querySelectorAll('button[name="add"]');
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      if (button.closest('.card-product')) continue; /* cards are handled below */
      var formId = button.getAttribute('form');
      var form = formId ? document.getElementById(formId) : button.closest('form');
      var idField = form && form.querySelector('input[name="id"], select[name="id"]');
      var item = itemFor(idField && idField.value);
      var label = button.querySelector('.x-atc-text') || button.querySelector('.button-text');
      var note = form && form.querySelector('.preorder-note');
      var title = document.querySelector('h1.product-title');
      var badge = title && title.parentElement.querySelector('.preorder-badge');

      if (!item) {
        if (label && label.dataset.preorderOriginal) {
          label.textContent = label.dataset.preorderOriginal;
          delete label.dataset.preorderOriginal;
        }
        if (note) note.remove();
        if (badge) badge.remove();
        continue;
      }
      if (title && !badge) {
        badge = makeBadge(item, 'preorder-badge');
        badge.style.marginBottom = '10px';
        title.insertAdjacentElement('beforebegin', badge);
      }
      if (badge) setText(badge, badgeText(item));
      if (label) {
        if (!label.dataset.preorderOriginal) label.dataset.preorderOriginal = label.textContent;
        setText(label, buttonLabel(item));
      }
      if (form && !note) {
        note = document.createElement('div');
        note.className = 'preorder-note text-sm mt-1 mb-3 opacity-80';
        button.insertAdjacentElement('afterend', note);
      }
      if (note) {
        setText(note, 'Part of our ' + item.label + ', launching ' + longDate(item.from)
          + '. Order now and choose a delivery date from then at checkout.');
      }
    }
  }

  /* ---------- 2. Product cards ---------- */

  function applyToCards() {
    var cards = document.querySelectorAll('.card-product');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var idField = card.querySelector('input[name="id"]');
      var item = itemFor(idField && idField.value);
      var button = card.querySelector('button.button--quickview');
      var label = button && button.querySelector('.button-text');
      var holder = card.querySelector('.label-container') || card.querySelector('.card-product > div');
      var badge = card.querySelector('.preorder-card-badge');
      if (item && holder && !badge) {
        badge = makeBadge(item, 'preorder-card-badge');
        holder.insertAdjacentElement('afterbegin', badge);
      } else if (!item && badge) {
        badge.remove();
      }
      if (item && badge) setText(badge, badgeText(item));
      if (!label) continue;
      if (item) {
        if (!label.dataset.preorderOriginal) label.dataset.preorderOriginal = label.textContent;
        setText(label, 'Pre-order');
        if (button.title !== buttonLabel(item)) button.title = buttonLabel(item);
      } else if (label.dataset.preorderOriginal) {
        label.textContent = label.dataset.preorderOriginal;
        button.removeAttribute('title');
        delete label.dataset.preorderOriginal;
      }
    }
  }

  /* ---------- 3. Cart notice ---------- */

  var nativeFetch = window.fetch;
  var lastCart = null;

  function noticeText(lines) {
    var names = [];
    var labels = [];
    var earliest = null;
    lines.forEach(function (line) {
      if (names.indexOf(line.title) === -1) names.push(line.title);
      if (labels.indexOf(line.label) === -1) labels.push(line.label);
      if (!earliest || line.from > earliest) earliest = line.from;
    });
    var list = names.length === 1 ? names[0]
      : names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1];
    var what = labels.length === 1 ? labels[0] + ' pre-order items' : 'pre-order items';
    return 'Your basket includes ' + what + ' (' + list + ') that can only be delivered from '
      + longDate(earliest) + ', so earlier dates are unavailable in the calendar. Choose a date from '
      + longDate(earliest) + ', or remove these items to order for an earlier date.';
  }

  function renderNotice(cart) {
    var lines = [];
    (cart && cart.items ? cart.items : []).forEach(function (line) {
      var item = itemFor(line.variant_id);
      if (item) lines.push(item);
    });

    /* The theme's own "Estimated delivery earliest ..." line in the cart
       only knows the store-wide lead time, so it is hidden while a
       pre-order item is in the basket and put back when it leaves. */
    var estimates = document.querySelectorAll('.x-estimate-delivery');
    for (var e = 0; e < estimates.length; e++) {
      var block = estimates[e];
      if (!/Estimated delivery/i.test(block.textContent) && !block.dataset.preorderHidden) continue;
      if (lines.length) {
        if (!block.hidden) { block.hidden = true; block.dataset.preorderHidden = '1'; }
      } else if (block.dataset.preorderHidden) {
        block.hidden = false;
        delete block.dataset.preorderHidden;
      }
    }

    /* Sit above the delivery date picker when the app has rendered it,
       otherwise above the checkout button. */
    var anchors = document.querySelectorAll('#dsDatePikerBlock');
    if (!anchors.length) anchors = document.querySelectorAll('button[name="checkout"]');
    var seen = [];
    for (var i = 0; i < anchors.length; i++) {
      var anchor = anchors[i];
      var host = anchor.id === 'dsDatePikerBlock' ? anchor : anchor.closest('form') || anchor;
      if (seen.indexOf(host) !== -1) continue;
      seen.push(host);
      var notice = host.previousElementSibling;
      if (!(notice && notice.classList.contains('preorder-cart-notice'))) notice = null;

      if (!lines.length) {
        if (notice) notice.remove();
        continue;
      }
      if (!notice) {
        notice = document.createElement('div');
        notice.className = 'preorder-cart-notice text-sm rounded-md mt-4 mb-2 pt-3 pb-3 pl-4 pr-4 border border-solid';
        notice.style.borderColor = '#10846f';
        notice.style.background = 'rgba(16, 132, 111, 0.08)';
        host.insertAdjacentElement('beforebegin', notice);
      }
      setText(notice, noticeText(lines));
    }
  }

  function refreshCart() {
    nativeFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { lastCart = cart; renderNotice(cart); })
      .catch(function () {});
  }

  function isCartWrite(url) {
    return typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url);
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = nativeFetch.apply(this, arguments);
    if (isCartWrite(url)) {
      result.then(function () { window.setTimeout(refreshCart, 400); }, function () {});
    }
    return result;
  };

  /* ---------- Boot ---------- */

  var scheduled = null;
  function schedule() {
    if (scheduled) return;
    scheduled = window.setTimeout(function () {
      scheduled = null;
      if (Object.keys(items).length) {
        applyToProductButtons();
        applyToCards();
      }
      if (lastCart) renderNotice(lastCart);
    }, 150);
  }

  document.addEventListener('alpine:initialized', schedule);
  window.addEventListener('load', function () {
    schedule();
    if (Object.keys(items).length) refreshCart();
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') schedule();
  }, true);
  if ('MutationObserver' in window) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
